export enum QueryKeyEnum {
  ADMIN_NEWS = 'ADMIN_NEWS',
  ADMIN_NEWS_DETAIL = 'ADMIN_NEWS_DETAIL',
  ADMIN_NEWS_VIDEO_PLAYBACK = 'ADMIN_NEWS_VIDEO_PLAYBACK',
  APP_STATS = 'APP_STATS',
  AREA_ACTIVITIES = 'AREA_ACTIVITIES',
  AREA_ATTRITION_RISK = 'AREA_ATTRITION_RISK',
  AREA_EMPLOYEE_ACTIVITIES = 'AREA_EMPLOYEE_ACTIVITIES',
  AREA_EMPLOYEES = 'AREA_EMPLOYEES',
  AREA_HR_EVENTS_COUNT = 'AREA_HR_EVENTS_COUNT',
  AREA_HR_EVENTS_DAILY = 'AREA_HR_EVENTS_DAILY',
  AREA_HR_EVENTS_LIST = 'AREA_HR_EVENTS_LIST',
  AREA_HR_EVENTS_PAGE = 'AREA_HR_EVENTS_PAGE',
  AREA_HR_EVENTS_SUMMARY = 'AREA_HR_EVENTS_SUMMARY',
  AREA_INDICATORS = 'AREA_INDICATORS',
  AREA_MATRIX = 'AREA_MATRIX',
  AREA_MATRIX_CATEGORY = 'AREA_MATRIX_CATEGORY',
  AREA_PMC_DISTRIBUTION = 'AREA_PMC_DISTRIBUTION',
  AREA_STATISTICS = 'AREA_STATISTICS',
  AREA_TEAM_SUPERVISORS = 'AREA_TEAM_SUPERVISORS',
  AVAILABLE_SECTIONS = 'AVAILABLE_SECTIONS',
  CANDIDATE_TEST_RESULT = 'CANDIDATE_TEST_RESULT',
  CANDIDATE_TEST_RESULT_VISIBILITY = 'CANDIDATE_TEST_RESULT_VISIBILITY',
  CATEGORIES_BELOW_THRESHOLD = 'CATEGORIES_BELOW_THRESHOLD',
  CERTIFICATION_PARTICIPANTS = 'CERTIFICATION_PARTICIPANTS',
  CERTIFICATION_PLAN_STAGE = 'CERTIFICATION_PLAN_STAGE',
  CERTIFICATIONS = 'CERTIFICATIONS',
  CHAT_DOCUMENTS = 'CHAT_DOCUMENTS',
  CHAT_MESSAGE_STATUS = 'CHAT_MESSAGE_STATUS',
  COMMISSION_CANDIDATES_SEARCH = 'COMMISSION_CANDIDATES_SEARCH',
  CURRENT_SURVEY_QUESTION = 'CURRENT_SURVEY_QUESTION',
  CURRENT_TEST_QUESTION = 'CURRENT_TEST_QUESTION',
  CURRENT_USER = 'CURRENT_USER',
  CURRENT_USER_ROLE = 'CURRENT_USER_ROLE',
  DEVELOPMENT_CENTER_CONFIG = 'DEVELOPMENT_CENTER_CONFIG',
  DEVELOPMENT_CENTER_IMPORTS = 'DEVELOPMENT_CENTER_IMPORTS',
  DEVELOPMENT_CENTER_PARTICIPANTS = 'DEVELOPMENT_CENTER_PARTICIPANTS',
  DEVELOPMENT_CYCLE_CAMPAIGN_MEMBER_DETAIL = 'DEVELOPMENT_CYCLE_CAMPAIGN_MEMBER_DETAIL',
  DEVELOPMENT_CYCLE_CAMPAIGN_MEMBERS = 'DEVELOPMENT_CYCLE_CAMPAIGN_MEMBERS',
  DEVELOPMENT_CYCLE_CAMPAIGNS = 'DEVELOPMENT_CYCLE_CAMPAIGNS',
  DICTIONARIES = 'DICTIONARIES',
  DICTIONARY_TYPES = 'DICTIONARY_TYPES',
  DISABLED_FEATURE_FLAGS = 'DISABLED_FEATURE_FLAGS',
  EMPLOYEE_AVATAR = 'EMPLOYEE_AVATAR',
  EMPLOYEE_PROFILE = 'EMPLOYEE_PROFILE',
  EMPLOYEE_PROFILE_AVAILABLE_DEVELOPMENT_PATHS = 'EMPLOYEE_PROFILE_AVAILABLE_DEVELOPMENT_PATHS',
  EMPLOYEE_PROFILE_DEVELOPMENT_PATH_CYCLE_STATE_CHANGES = 'EMPLOYEE_PROFILE_DEVELOPMENT_PATH_CYCLE_STATE_CHANGES',
  EMPLOYEE_PROFILE_DEVELOPMENT_PLAN_INITIATION_STATUS = 'EMPLOYEE_PROFILE_DEVELOPMENT_PLAN_INITIATION_STATUS',
  EMPLOYEE_PROFILE_INDIVIDUAL_DEVELOPMENT_PATH = 'EMPLOYEE_PROFILE_INDIVIDUAL_DEVELOPMENT_PATH',
  EMPLOYEE_PROFILE_INDIVIDUAL_DEVELOPMENT_PATH_CYCLE = 'EMPLOYEE_PROFILE_INDIVIDUAL_DEVELOPMENT_PATH_CYCLE',
  EMPLOYEE_PROFILE_INDIVIDUAL_DEVELOPMENT_PATH_STATUS = 'EMPLOYEE_PROFILE_INDIVIDUAL_DEVELOPMENT_PATH_STATUS',
  EMPLOYEE_PROFILE_INDIVIDUAL_DEVELOPMENT_PATHS_CYCLES = 'EMPLOYEE_PROFILE_INDIVIDUAL_DEVELOPMENT_PATHS_CYCLES',
  EMPLOYEE_PROFILES_SEARCH_BY_TEXT = 'EMPLOYEE_PROFILES_SEARCH_BY_TEXT',
  EMPLOYEE_TALENT_PANELS = 'EMPLOYEE_TALENT_PANELS',
  EXAM_COMMISSION_MEMBERS = 'EXAM_COMMISSION_MEMBERS',
  EXAM_DAY_AVAILABLE_PARTICIPANTS = 'EXAM_DAY_AVAILABLE_PARTICIPANTS',
  EXAM_DAY_DETAIL = 'EXAM_DAY_DETAIL',
  EXAM_DAYS = 'EXAM_DAYS',
  EXAM_PARTICIPANTS = 'EXAM_PARTICIPANTS',
  EXAM_STAGE_CONFIG = 'EXAM_STAGE_CONFIG',
  EXAM_STAGE_SUMMARY = 'EXAM_STAGE_SUMMARY',
  EXAMINEE_EXAM_PAGES_COUNT = 'EXAMINEE_EXAM_PAGES_COUNT',
  EXAMINEE_EXAM_VIEW = 'EXAMINEE_EXAM_VIEW',
  EXTRA_COMMISSION_MEMBER_CANDIDATES = 'EXTRA_COMMISSION_MEMBER_CANDIDATES',
  EXTRA_COMMISSION_MEMBERS = 'EXTRA_COMMISSION_MEMBERS',
  FLASHCARD_DOWNLOADS = 'FLASHCARD_DOWNLOADS',
  GROUP_TRAINING = 'GROUP_TRAINING',
  GROUP_TRAININGS = 'GROUP_TRAININGS',
  HIERARCHY_NODES_SEARCH = 'HIERARCHY_NODES_SEARCH',
  HIERARCHY_ROOT_NODES = 'HIERARCHY_ROOT_NODES',
  HIERARCHY_SIMULATIONS = 'HIERARCHY_SIMULATIONS',
  INDIVIDUAL_EXAM_DETAIL = 'INDIVIDUAL_EXAM_DETAIL',
  LATEST_NEWS = 'LATEST_NEWS',
  LEGAL_DOCUMENT_CURRENT = 'LEGAL_DOCUMENT_CURRENT',
  LEGAL_DOCUMENT_VERSIONS = 'LEGAL_DOCUMENT_VERSIONS',
  LIST_DICTIONARIES = 'LIST_DICTIONARIES',
  LIST_PROFESSIONAL_ACTIVITY_DEFINITIONS = 'LIST_PROFESSIONAL_ACTIVITY_DEFINITIONS',
  MY_CERTIFICATIONS = 'MY_CERTIFICATIONS',
  NOTIFICATIONS = 'NOTIFICATIONS',
  ORGANIZATIONAL_UNITS_HIERARCHY = 'ORGANIZATIONAL_UNITS_HIERARCHY',
  PRACTICAL_EXAM_ATTEMPT_DETAIL = 'PRACTICAL_EXAM_ATTEMPT_DETAIL',
  PRACTICAL_EXAM_ATTEMPTS = 'PRACTICAL_EXAM_ATTEMPTS',
  PRACTICAL_EXAM_POOL_DETAIL = 'PRACTICAL_EXAM_POOL_DETAIL',
  PRACTICAL_EXAM_POOLS_LIST = 'PRACTICAL_EXAM_POOLS_LIST',
  PRACTICAL_EXAM_STAGE_POOLS = 'PRACTICAL_EXAM_STAGE_POOLS',
  PRACTICAL_EXAM_STATISTICS = 'PRACTICAL_EXAM_STATISTICS',
  PROFESSIONAL_ACTIVITIES = 'PROFESSIONAL_ACTIVITIES',
  PROFESSIONAL_ACTIVITY_DEFINITION_DETAIL = 'PROFESSIONAL_ACTIVITY_DEFINITION_DETAIL',
  PROFESSIONAL_ACTIVITY_DEFINITION_DOCUMENTS = 'PROFESSIONAL_ACTIVITY_DEFINITION_DOCUMENTS',
  PROFESSIONAL_ACTIVITY_DOCUMENTS = 'PROFESSIONAL_ACTIVITY_DOCUMENTS',
  PUBLISHED_NEWS = 'PUBLISHED_NEWS',
  PUBLISHED_NEWS_DETAIL = 'PUBLISHED_NEWS_DETAIL',
  QUESTION_POOL_SEARCH = 'QUESTION_POOL_SEARCH',
  QUESTION_POOLS_LIST = 'QUESTION_POOLS_LIST',
  SECTION_DATA = 'SECTION_DATA',
  SECTIONS_SUPPORTED = 'SECTIONS_SUPPORTED',
  SIMULATION_ACCESS = 'SIMULATION_ACCESS',
  SIMULATION_POSITIONS = 'SIMULATION_POSITIONS',
  STAGE_PARTICIPANTS = 'STAGE_PARTICIPANTS',
  STAGE_QUESTION_POOLS = 'STAGE_QUESTION_POOLS',
  STAGE_QUESTIONS_SEARCH = 'STAGE_QUESTIONS_SEARCH',
  STRUCTURE_PEOPLE = 'STRUCTURE_PEOPLE',
  STRUCTURE_SUPERVISORS = 'STRUCTURE_SUPERVISORS',
  STRUCTURE_TEAM = 'STRUCTURE_TEAM',
  SUCCESSION_CHANGELOG_HISTORY = 'SUCCESSION_CHANGELOG_HISTORY',
  SUCCESSION_DASHBOARD = 'SUCCESSION_DASHBOARD',
  SUCCESSION_EMPLOYEE_CAREER_PATHS = 'SUCCESSION_EMPLOYEE_CAREER_PATHS',
  SUCCESSION_SEARCH_INFINITE = 'SUCCESSION_SEARCH_INFINITE',
  SUCCESSION_SUCCESSOR_DETAIL = 'SUCCESSION_SUCCESSOR_DETAIL',
  SUPERVISOR_BIRTHDAYS = 'SUPERVISOR_BIRTHDAYS',
  SURVEY_EXECUTION_STATUS = 'SURVEY_EXECUTION_STATUS',
  SURVEYS = 'SURVEYS',
  TASKS = 'TASKS',
  TEAM_EMPLOYEES = 'TEAM_EMPLOYEES',
  TEAM_STATISTICS = 'TEAM_STATISTICS',
  TEST_ANSWER_DISTRIBUTION = 'TEST_ANSWER_DISTRIBUTION',
  TEST_EXECUTION_STATUS = 'TEST_EXECUTION_STATUS',
  TEST_QUESTION_BY_NUMBER = 'TEST_QUESTION_BY_NUMBER',
  TEST_STAGE_CONFIG = 'TEST_STAGE_CONFIG',
  TEST_TERM_AVAILABLE_PARTICIPANTS = 'TEST_TERM_AVAILABLE_PARTICIPANTS',
  TEST_TERM_PARTICIPANTS = 'TEST_TERM_PARTICIPANTS',
  TEST_TERM_RESULT_DETAIL = 'TEST_TERM_RESULT_DETAIL',
  TEST_TERM_RESULTS = 'TEST_TERM_RESULTS',
  TEST_TERMS = 'TEST_TERMS',
  VALIDATION_ERROR_STATISTICS = 'VALIDATION_ERROR_STATISTICS',
  VALIDATION_ERRORS = 'VALIDATION_ERRORS',
  VALIDATION_ERRORS_BY_TYPE = 'VALIDATION_ERRORS_BY_TYPE',
}
